<template>
  <v-dialog
    v-model="isVisible"
    v-bind="$attrs"
    width="auto "
    persistent
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text v-if="!!$slots.default">
        <slot />
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          v-if="!hideCancelBtn"
          ref="cancelBtn"
          outlined
          :color="cancelBtnColor"
          :class="cancelBtnClass"
          @click.native="cancel"
          >{{ cancelBtnText }}</v-btn
        >
        <v-btn
          id="confirm-button"
          outlined
          :color="confirmBtnColor"
          :class="confirmBtnClass"
          @click.native="confirm"
          >{{ confirmBtnText }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Confirm?",
    },
    confirmBtnText: {
      type: String,
      default: "Yes",
    },
    confirmBtnColor: {
      type: String,
      default: "primary",
    },
    confirmBtnClass: {
      type: String,
      default: "ml-4",
    },
    cancelBtnText: {
      type: String,
      default: "No",
    },
    cancelBtnColor: {
      type: String,
      default: "",
    },
    cancelBtnClass: {
      type: String,
      default: "",
    },
    hideCancelBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
      resolve: null,
    };
  },
  methods: {
    show() {
      this.isVisible = true;
      setTimeout(() => this.$refs.cancelBtn.$el.focus(), 250);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
      });
    },
    confirm() {
      this.resolve(true);
      this.isVisible = false;
    },
    cancel() {
      this.resolve(false);
      this.isVisible = false;
    },
  },
};
</script>
